import { render, staticRenderFns } from "./inspectDetail.vue?vue&type=template&id=3cf25e5e&scoped=true&"
import script from "./inspectDetail.vue?vue&type=script&lang=js&"
export * from "./inspectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf25e5e",
  null
  
)

export default component.exports